import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { DateFormatter, DateTimeFormatter } from '../../../shared/controls/formatters';
import {
  getCommonNumberFilterParams,
  getCommonTextFilterParams,
  getSetCheckboxFilterParams,
  getSetDatefilterParams,
  getSetFilterParams,
} from '../../../utils/agGridFilters';

// const OptionButton = ({
//     handleOpenEditForm,
//     paramsValue,
//     handleOpenViewForm,
//     handleClickOpenConvertLead,
//     rowData,
//     handleClickDelete,
//     emailPopup,
//     hasDeleteLeadPermission,
//     hasUpdateLeadPermission,
//     hasInfoLeadPermission,
// }) => {
//     // const [isHover, setHover] = useState(false);
//     const [showConfirmation, setShowConfirmation] = useState(false);
//     const handleDeleteClick = (e) => {
//         e.preventDefault();
//         setShowConfirmation(true);
//     };

//     const handleConfirmDelete = () => {
//         console.log("rowData==>", rowData);
//         handleClickDelete(rowData);
//         setShowConfirmation(false);
//     };

//     const handleCloseConfirmation = () => {
//         setShowConfirmation(false);
//     };
//     return (
//         <div className="action-menu ">
//             {hasUpdateLeadPermission && (
//                 <img
//                     src="/assets/images/edit.png"
//                     className="action-img1"
//                     onClick={handleOpenEditForm}
//                     alt="Edit Lead"
//                     title="Edit Lead"
//                 />
//             )}
//             {hasInfoLeadPermission && (
//                 <img
//                     src="/assets/images/view.png"
//                     className="action-img2"
//                     onClick={handleOpenViewForm}
//                     alt="View Lead"
//                     title="View Lead"
//                 />
//             )}
//             <div className="dropdown">
//                 <span
//                     className="dropdown-toggle"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                 >
//                     <img
//                         src="/assets/images/crm/leads/actiondot.svg"
//                         className="action-img1 dropdown-toggle"
//                         width="18px"
//                         alt="More"
//                         title="More"
//                     />
//                 </span>

//                 <ul className="dropdown-menu">
//                     {hasUpdateLeadPermission && (
//                         <li className="dropdown-item">
//                             <Link to="/leads/editLead" state={rowData}>
//                                 Edit
//                             </Link>
//                         </li>
//                     )}
//                     <li className="dropdown-item">
//                         <Link to="/leads/convertLead" state={rowData}>
//                             Convert
//                         </Link>
//                     </li>
//                     {hasDeleteLeadPermission && (
//                         <li className="dropdown-item">
//                             <Link onClick={handleDeleteClick}>Delete</Link>
//                             <DeleteConfirmationModal
//                                 show={showConfirmation}
//                                 handleClose={handleCloseConfirmation}
//                                 handleConfirm={handleConfirmDelete}
//                                 content={"lead"}
//                             />
//                         </li>
//                     )}

//                 </ul>
//             </div>
//         </div>
//     );
// };

const useQuoteColumnDefs = ({ gridData, accountDropdown, owner }) => {
  const commonTextFilterParams = useMemo(() => getCommonTextFilterParams(), []);
  const commonNumberFilterParams = useMemo(() => getCommonNumberFilterParams(), []);
  const dateFilterParams = useMemo(() => getSetDatefilterParams(), []);
  const checkboxFilterParams = useMemo(() => getSetCheckboxFilterParams, []);
  const filterParams = useMemo(() => getSetFilterParams, []);

  const columnDefs = useMemo(() => {
    // No Actions column — view is reached via the Code link (edit via the view page).
    return [
      {
        headerName: 'Code',
        field: 'code',
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
        minWidth: 160,
        cellRenderer: (params) => {
          if (!params.value) return null;
          return (
            <Link
              to={`/quoteAI/regularQuoteView?id=${params?.data?.id}`}
              state={{ ...params.data }}
              className="gos-lead-name"
            >
              {params.value}
            </Link>
          );
        },
      },
      {
        headerName: 'Subject',
        field: 'subject',
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Account Name',
        field: 'accountName',
        filter: 'agSetColumnFilter',
        filterParams: filterParams(accountDropdown.map((item) => item.name)),
      },
      {
        headerName: 'Valid Until',
        field: 'validUntil',
        valueFormatter: DateFormatter,
        filter: 'agDateColumnFilter',
        filterParams: dateFilterParams,
      },
      {
        headerName: 'Total Amount',
        field: 'grandTotal',
        width: 80,
        filter: 'agNumberColumnFilter',
        filterParams: commonNumberFilterParams,
      },
      {
        headerName: 'Created Date',
        field: 'createdDateTime',
        filter: 'agDateColumnFilter',
        valueFormatter: DateTimeFormatter,
        filterParams: dateFilterParams,
      },
      {
        headerName: 'Quote Owner',
        field: 'quoteOwner',
        filter: 'agSetColumnFilter',
        filterParams: filterParams(owner.map((item) => item.display_name)),
      },
    ];
  }, [
    gridData,
    commonTextFilterParams,
    commonNumberFilterParams,
    dateFilterParams,
    checkboxFilterParams,
    filterParams,
    accountDropdown,
    owner,
  ]);

  return columnDefs;
};

export default useQuoteColumnDefs;
